import { useEffect } from 'react';

import { CortexaLogo } from '@shared/ui/cortexa-logo';
import { Kbd } from '@shared/ui/kbd';

interface AppSidebarAIChatButtonProps {
  onOpenChat: (initialMessage?: string) => void;
}

export function AppSidebarAIChatButton({ onOpenChat }: AppSidebarAIChatButtonProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // ⌘K or Ctrl+K
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        onOpenChat();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onOpenChat]);

  return (
    <div
      className="
        relative my-5 hidden
        sm:flex
      "
    >
      <button
        type="button"
        onClick={() => {
          onOpenChat();
        }}
        aria-label="Open Cortexa AI chat"
        className="
          inline-flex w-full items-center justify-between gap-2 rounded-full bg-background-0 px-3
          py-2.5 text-sm font-normal shadow-md ring-1 ring-ring transition-all outline-none
          hover:shadow-lg
          focus-visible:ring-2 focus-visible:ring-ring/20
        "
      >
        <CortexaLogo
          keepColors={false}
          size="sm"
          icon={true}
          className="size-5 shrink-0 text-foreground"
        />
        <span className="w-6/10 grow text-left text-sm text-muted-foreground/70">
          Ask Cortexa AI...
        </span>
        <Kbd className="shrink-0 rounded-md bg-background-3 text-xs">⌘K</Kbd>
      </button>
    </div>
  );
}
